module.exports = __webpack_public_path__ + "static/assets/e587d9d7e9a2f1f28041ba5c15db7a40.svg";